import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar.jsx';

const SIDEBAR_STATE_KEY = 'feedback-hero-sidebar-open';
const DESKTOP_BREAKPOINT = 768;

const BODY_GRADIENT = [
  // halo verde sutil no canto superior esquerdo (combina com sidebar dark green #153023)
  'radial-gradient(1100px circle at 8% -10%, rgba(46, 139, 87, 0.12) 0%, transparent 55%)',
  // halo verde mais frio no canto inferior direito (mesmo accent do painel #2E8B57)
  'radial-gradient(1000px circle at 100% 100%, rgba(31, 92, 58, 0.09) 0%, transparent 60%)',
  // gradiente diagonal base: verde-pálido → cream (pageBg)
  'linear-gradient(135deg, #EAF7EE 0%, #F1F6EF 35%, #F6F4F1 65%, #E9F3EC 100%)',
].join(', ');

const getIsDesktop = () =>
  typeof window === 'undefined' ? true : window.innerWidth >= DESKTOP_BREAKPOINT;

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      const stored = sessionStorage.getItem(SIDEBAR_STATE_KEY);
      if (stored === null) return true;
      return stored === 'true';
    } catch (_) {
      return true;
    }
  });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(getIsDesktop);

  useEffect(() => {
    try {
      sessionStorage.setItem(SIDEBAR_STATE_KEY, String(sidebarOpen));
    } catch (_) {}
  }, [sidebarOpen]);

  useEffect(() => {
    const handler = () => setIsDesktop(getIsDesktop());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const handleToggleSidebar = () => {
    if (!isDesktop) {
      setMobileMenuOpen((prev) => !prev);
      return;
    }
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className="flex h-screen text-slate-800"
      style={{ background: BODY_GRADIENT }}
    >
      <Sidebar
        open={sidebarOpen}
        mobileOpen={mobileMenuOpen}
        isDesktop={isDesktop}
        onNavigate={() => setMobileMenuOpen(false)}
        onToggle={handleToggleSidebar}
      />
      {!isDesktop && mobileMenuOpen && (
        <button
          type="button"
          aria-label="Fechar menu"
          onClick={() => setMobileMenuOpen(false)}
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
        />
      )}
      {!isDesktop && !mobileMenuOpen && (
        <button
          type="button"
          onClick={handleToggleSidebar}
          aria-label="Abrir menu"
          className="fixed top-3 left-3 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-lg transition-all hover:bg-slate-50 active:scale-95 md:hidden"
        >
          <Menu size={22} />
        </button>
      )}
      <div className="flex flex-col flex-1 min-w-0">
        <main className="relative flex-1 overflow-y-auto p-4 pt-2 md:p-6 md:pt-2">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default Layout;
